import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';


@Injectable({
  providedIn: 'root'
})
export class JwtDecodeService {
  decode(token: string) {
    return jwtDecode(token);
  }
}
